/*
* @module : ProtectedRoute
* @file : ProtectedRoute.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of ProtectedRoute
*
* Created on : 11-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 24-Oct-2019
*/
import React from 'react';
import {Redirect,Route} from 'react-router-dom';

class ProtectedRoute extends React.Component
{
	render() {
    const { component: Component, ...props } = this.props
    let session_id = sessionStorage.getItem('session_id');
    return (
      <Route 
        {...props} 
        render={props => (
          typeof session_id !== "undefined" && session_id !== null ?
            <Component {...props} /> :
            <Redirect to='/' />
        )} 
      />
    )
  }
}

export default ProtectedRoute;